import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=3348001e&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=tsx&"
export * from "./Info.vue?vue&type=script&lang=tsx&"
import style0 from "./Info.vue?vue&type=style&index=0&id=3348001e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3348001e",
  null
  
)

export default component.exports